// removed by extract-text-webpack-plugin
module.exports = {"card":"Card-card--tRKnc","cardContent":"Card-cardContent--3J66l","flipped":"Card-flipped--3Db3G","cardFront":"Card-cardFront--3oyDw","cardBack":"Card-cardBack--1Lkmt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/Card.scss
// module id = 9kH4
// module chunks = 1